import {stringify} from 'qs'
import request from 'message-control/utils/request'
import {format} from 'utils'
import api from './api'

export async function getList(payload) {
    return request(`${api.getList.url}?${stringify(payload?.params)}`)
}
export async function getAssessWord() {
    return request(api.getAssessWord.url)
}
export async function postRule(payload) {
    return request(api.postRule.url, {
        method: api.postRule.type,
        body: payload.body,
    })
}
export async function postAssessWord(payload) {
    return request(api.postAssessWord.url, {
        method: api.postAssessWord.type,
        body: payload.body,
    })
}
export async function deleteRule(payload) {
    return request(format(api.deleteRule.url, {id: payload.id}), {
        method: api.deleteRule.type,
    })
}
